import { render, staticRenderFns } from "./goals-content.vue?vue&type=template&id=0b58e304&scoped=true&"
import script from "./goals-content.vue?vue&type=script&lang=js&"
export * from "./goals-content.vue?vue&type=script&lang=js&"
import style0 from "./goals-content.vue?vue&type=style&index=0&id=0b58e304&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58e304",
  null
  
)

export default component.exports